import { frontendURL } from 'dashboard/helper/URLHelper';
import SegueDashboardIndex from './Index.vue';
import SegueDashboardOfertas from './Ofertas.vue';
import SegueDashboardContratos from './Contratos.vue';
import SegueDashboardEquipe from './Equipe.vue';

// v90: o Dashboard virou um grupo com sub-páginas (padrão do menu
// Configurações): Visão Geral, Ofertas, Contratos e Equipe.
export const routes = [
  {
    // Path único para evitar conflito com a rota "home" do Chatwoot
    // (que usa /accounts/:accountId/dashboard como tela default de conversas).
    // A rota antiga redireciona pra Visão Geral (links salvos continuam OK).
    path: frontendURL('accounts/:accountId/segue-dashboard'),
    name: 'segue_dashboard',
    redirect: { name: 'segue_dashboard_visao' },
  },
  {
    path: frontendURL('accounts/:accountId/segue-dashboard/visao-geral'),
    name: 'segue_dashboard_visao',
    component: SegueDashboardIndex,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/segue-dashboard/ofertas'),
    name: 'segue_dashboard_ofertas',
    component: SegueDashboardOfertas,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/segue-dashboard/contratos'),
    name: 'segue_dashboard_contratos',
    component: SegueDashboardContratos,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/segue-dashboard/equipe'),
    name: 'segue_dashboard_equipe',
    component: SegueDashboardEquipe,
    meta: {
      permissions: ['administrator'],
    },
  },
];

export default { routes };
